export default __webpack_public_path__ + "static/media/footer-banner.ccea0f84.webp";